const createAngularApp = require('../2-create');
const registerAngularServices = require('../services/1-di-config');
const { configureAngularApp, registerAngularControllers, registerAngularDirectives, registerAngularFilters, registerAngularResources } = require('../3-configure');

// This comes from the grunt task "html2js" and contains the contents of the partials directory.
// It creates an Angular module called 'templates-main'.
// eslint-disable-next-line sort-imports-requires/sort-requires
require('@/../../temp/js/templates');

/**
 * This creates an Angular instance, registers all our stuff, and configures it.
 * All that's left to do is call app.run() on the returned object.
 *
 * @param {Function} registerRoutes
 *
 * @return {angular.Module}
 */
const angularAppFactory = (registerRoutes) => {
    const app = createAngularApp();

    // TODO: Only register directives, controllers, and filters on the apps using Angular for UI
    // (epos + kitchen-customer)
    registerAngularDirectives(app);
    registerAngularControllers(app);
    registerAngularFilters(app);

    // Angular resources and services are required even if using Vue for UI, because these are the backend services.
    registerAngularResources(app);
    registerAngularServices(app);

    global.app = app;
    // TODO: Move these to epos only.
    require('@/services/CloverServices');
    require('@/services/DojoServices');
    require('@/services/PayyoServices');
    require('@/services/VerifoneServices');
    require('@/services/WorldpayServices');
    delete global.app;

    configureAngularApp(app, registerRoutes);

    return app;
};

module.exports = angularAppFactory;
